// extracted by mini-css-extract-plugin
export default {"root":"Error_root__+jXTw","robot":"Error_robot__gv3BS","content":"Error_content__jJV7P","link":"Error_link__bemAP"};